import '../../assets/index22.css';var T = Object.defineProperty, j = Object.defineProperties;
var q = Object.getOwnPropertyDescriptors;
var a = Object.getOwnPropertySymbols;
var d = Object.prototype.hasOwnProperty, u = Object.prototype.propertyIsEnumerable;
var f = (i, o, t) => o in i ? T(i, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[o] = t, s = (i, o) => {
  for (var t in o || (o = {}))
    d.call(o, t) && f(i, t, o[t]);
  if (a)
    for (var t of a(o))
      u.call(o, t) && f(i, t, o[t]);
  return i;
}, N = (i, o) => j(i, q(o));
var p = (i, o) => {
  var t = {};
  for (var c in i)
    d.call(i, c) && o.indexOf(c) < 0 && (t[c] = i[c]);
  if (i != null && a)
    for (var c of a(i))
      o.indexOf(c) < 0 && u.call(i, c) && (t[c] = i[c]);
  return t;
};
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import D from "react";
import { c as E } from "../../factory-ueRxoNOV.js";
import { XMarkFarFAIcon as G, CircleExclamationFarFAIcon as H, TriangleExclamationFarFAIcon as Q, CheckCircleFarFAIcon as R } from "../Icons/index.js";
import { Button as g } from "../Button/index.js";
import { G as U } from "../../Group-CbE78j-X.js";
import { T as M } from "../../Transition-esp-rpzm.js";
const O = "Notification-module__notification___nI0iq", V = "Notification-module__icon___b9vhU", W = "Notification-module__message___-NZHQ", X = "Notification-module__content___iQDHV", Y = "Notification-module__closeButton___I6Wcx", Z = "Notification-module__notificationActionBtn___Yiatt", J = "Notification-module__actions___zUDpN", K = "Notification-module__notificationsStack___iq4Sf", P = "Notification-module__notificationsContainer___aNOuN", $ = "Notification-module__slideIn___9yi-A", e = {
  notification: O,
  icon: V,
  message: W,
  content: X,
  closeButton: Y,
  notificationActionBtn: Z,
  actions: J,
  notificationsStack: K,
  notificationsContainer: P,
  slideIn: $
}, L = D.forwardRef((ii, y) => {
  var m = ii, {
    message: i,
    variant: o,
    withCloseButton: t = !0,
    onClose: c,
    className: h,
    visible: v = !0,
    actionLabel: l,
    onAction: _,
    transition: x = "slide-left",
    transitionDuration: C = 200,
    transitionTimingFunction: I = "ease",
    position: B = "bottom-right"
  } = m, F = p(m, [
    "message",
    "variant",
    "withCloseButton",
    "onClose",
    "className",
    "visible",
    "actionLabel",
    "onAction",
    "transition",
    "transitionDuration",
    "transitionTimingFunction",
    "position"
  ]);
  const z = {
    success: {
      icon: /* @__PURE__ */ n(R, { size: 16, filled: !0 }),
      color: "var(--plum-green-5)"
    },
    warning: {
      icon: /* @__PURE__ */ n(Q, { size: 16, filled: !0 }),
      color: "var(--plum-orange-5)"
    },
    error: {
      icon: /* @__PURE__ */ n(H, { size: 16, filled: !0 }),
      color: "var(--plum-red-5)"
    }
  }, { icon: A, color: k } = z[o], b = {
    "top-right": { top: 32, right: 32 },
    "top-left": { top: 32, left: 32 },
    "bottom-right": { bottom: 32, right: 32 },
    "bottom-left": { bottom: 32, left: 32 }
  }, S = /* @__PURE__ */ r(
    "div",
    N(s({
      className: E(e.notification, e[o], h),
      ref: y,
      role: "alert"
    }, F), {
      children: [
        /* @__PURE__ */ n("div", { className: e.content, children: /* @__PURE__ */ r(U, { gap: "xs", align: "center", wrap: "nowrap", children: [
          /* @__PURE__ */ n("div", { className: e.icon, style: { color: k }, children: A }),
          /* @__PURE__ */ n("div", { className: e.message, children: i })
        ] }) }),
        /* @__PURE__ */ r("div", { className: e.actions, children: [
          l && _ && /* @__PURE__ */ n(
            g,
            {
              variant: "tertiary",
              size: "sm",
              onClick: _,
              className: e.notificationActionBtn,
              children: l
            }
          ),
          t && /* @__PURE__ */ n(
            g,
            {
              variant: "tertiary",
              size: "sm",
              onClick: c,
              "aria-label": "Close notification",
              className: e.closeButton,
              leftSection: /* @__PURE__ */ n(G, { size: 16 })
            }
          )
        ] })
      ]
    })
  );
  return /* @__PURE__ */ n("div", { style: s({ position: "fixed", zIndex: 999 }, b[B]), children: /* @__PURE__ */ n(
    M,
    {
      mounted: v,
      transition: x,
      duration: C,
      timingFunction: I,
      children: (w) => /* @__PURE__ */ n("div", { style: w, children: S })
    }
  ) });
});
L.displayName = "Notification";
export {
  L as Notification
};
